import React from 'react';

const Constributors = ({ constributors }) => {
    const constributorsText = constributors.map(c => c.name).join(', ');

    return constributorsText && <p>Escrito por {constributorsText}</p>;
};

export default Constributors;